import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Stack, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { FiletypeXls } from 'react-bootstrap-icons'

import CurrentAccountSummaryTable from './CurrentAccountSummaryTable'
import { AppState } from '../../../reducers'
import { fetchCurrentAccountSummary } from '../../../actions/currentAccount/currentAccountSummary'
import { getToken } from '../../../utils/fetchApi'
import { CurrentAccountSummary } from '../../../models/CurrentAccountSummary'

import { useHistory, useLocation } from 'react-router-dom'
import { roleToURLPrefix } from '../../../App'
import { PERSON } from '../../../models/User'
import { isAdmin, SessionState } from '../../../reducers/auth/session'
import { Filters, FiltersBar } from '../../Utils/Filters/Filter'
import { FilterFromDate } from '../../Utils/Filters'
import { GeneralDescState } from '../../../reducers/generalDescList'


interface Props {
  summary?: CurrentAccountSummary[]
  isFetching: boolean
  generalDescList: GeneralDescState
  session: SessionState
}

const CurrentAccountSummaryList: React.FC<Props> = ({ summary = [], isFetching, session, generalDescList }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation('current')
  const history = useHistory()

  const location = useLocation()

  const urlParams = new URLSearchParams(location.search)

  const ctrlDateFromUrl = urlParams.get('ctrlDate')
  const hasCtrlDate = Boolean(ctrlDateFromUrl)

  const initDefaultFilters: Filters = {}

  const isValidCtrlDate = hasCtrlDate
    ? moment(ctrlDateFromUrl, ['YYYY-MM-DD', moment.ISO_8601], true).isValid()
    : true

  useEffect(() => {
    console.log('entro al useeffect del fetchcurrentaccountsummary', isValidCtrlDate)
    if (hasCtrlDate && !isValidCtrlDate) return

    dispatch(fetchCurrentAccountSummary(history.location.search))
  }, [dispatch, history.location.search, hasCtrlDate, isValidCtrlDate])


  const onClickDetail = (row: CurrentAccountSummary) => {
    const baseRole =
      session.roles && roleToURLPrefix(session.roles.filter(r => r !== PERSON)[0])

    const detailUrl = `/${baseRole}/currentAccounts/${row.codigo_cliente}${history.location.search}`

    history.push(detailUrl)
  }

  const handleDownload = async () => {
    try {
      const token = getToken()
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/currentAccounts/dlCurrentAccountSummary${history.location.search}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      )

      const blob = await res.blob()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `reporte_cc_clientes_${moment().format('YYYY-MM-DD')}_industrias_saladillo.xlsx`

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (err) {
      console.error('Error descargando Excel', err)
    }
  }

  const isAccounts = generalDescList?.generalDesc?.some(gd => gd.id === session?.categoryId && gd.code === 'cc') || isAdmin(session);

  return (
    <Stack
      sx={{
        height: '100vh',
        overflow: 'hidden'
      }}>
      {isAccounts && (
        <FiltersBar defaultFilters={initDefaultFilters} >
          <FilterFromDate name="ctrlDate" label={t("toDate")}/>
        </FiltersBar>
      )}

      <CurrentAccountSummaryTable
        rows={summary || []}
        loading={isFetching}
        isAccounts={isAccounts && !!ctrlDateFromUrl}
        onClickDetail={onClickDetail}
      />
      <Stack direction="row" justifyContent="flex-end" padding="10px">
        <Button
          variant="contained"
          onClick={handleDownload}
          size="large"
          style={{ textTransform: 'none' }}
        >
          {t('downloadDL', { ns: 'others' })}&nbsp;&nbsp;<FiletypeXls size={25} />
        </Button>
      </Stack>

    </Stack>
  )
}

const mapStateToProps = (state: AppState) => ({
  summary: state.currentAccountSummaryList.summary,
  isFetching: state.currentAccountSummaryList.isFetching,
  generalDescList: state.generalDescList,
  session: state.session
})

export default connect(mapStateToProps)(CurrentAccountSummaryList)
